import { Icons } from '@/components/Shares/Icons';
import { Flex, Text } from '@mantine/core';
export type WalletTabItemProps = {
  icon: string;
  title: string;
};
export const WalletTabItem: React.FC<WalletTabItemProps> = ({
  icon,
  title
}) => {
  return <Flex direction={{
    base: 'column',
    sm: 'row'
  }} justify="center" align="center" gap={8}>
      <Icons className={icon} fontSize={24} />
      <Text c="inherit" fz={{
      base: 10,
      sm: 12
    }} fw={700} tt="uppercase">
        {title}
      </Text>
    </Flex>;
};